export enum UserActionNotificationSuccessCode {
    UserRemoved = 13,
    UserAdded = 12,
    UserAssigned = 30
}
